// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"860":"911d89ed","862":"8c5d93bf","950":"32fd1f12"}[chunkId] + ".chunk.css";
};